import React from "react";
import { FiSettings } from "react-icons/fi";
import { BsDot } from "react-icons/bs";
import { RxDashboard } from "react-icons/rx";
import { FaUsers } from "react-icons/fa";
import { SiReadthedocs } from "react-icons/si";
import { FaArrowAltCircleRight } from "react-icons/fa";
import { createIconElement } from "utils/iconUtils";

export interface Submenu {
  title: string;
  to?: string;
  icon?: React.ReactNode;
  subRoutes?: Submenu[];
}

export const submenus: Submenu[] = [
  {
    title: "Dashboard",
    to: "/",
    icon: createIconElement(RxDashboard),
  },
  {
    title: "Getting Started",
    to: "/getting-started",
    icon: createIconElement(FaArrowAltCircleRight),
  },
  {
    title: "Configurations",
    icon: createIconElement(FiSettings),
    subRoutes: [
      {
        title: "Configurations List",
        to: "/configuration/list",
        icon: createIconElement(BsDot),
      },
      {
        title: "Add Configuration",
        to: "/configuration/add",
        icon: createIconElement(BsDot),
      },
    ],
  },
  {
    title: "Documentation",
    icon: createIconElement(SiReadthedocs),
    subRoutes: [
      {
        title: "Macos Steps",
        to: "/documentation/macos-steps",
        icon: createIconElement(BsDot),
      },
      {
        title: "Midjourney Steps",
        to: "/documentation/midjourney-steps",
        icon: createIconElement(BsDot),
      },
      {
        title: "OpenAI Steps",
        to: "/documentation/openai-steps",
        icon: createIconElement(BsDot),
      },
      {
        title: "Wordpress Integration",
        to: "/documentation/wordpress-integration",
        icon: createIconElement(BsDot),
      },
      {
        title: "Prompts examples",
        to: "/documentation/prompts",
        icon: createIconElement(BsDot),
      },
    ],
  },
  // {
  //   title: "Virtual Assistants",
  //   icon: React.createElement(FaUsers),
  //   subRoutes: [
  //     {
  //       title: "Virtual Assistants List",
  //       to: "/virtualassistant/list",
  //       icon: React.createElement(BsDot),
  //     },
  //     {
  //       title: "Add Virtual Assistant",
  //       to: "/virtualassistant/add",
  //       icon: React.createElement(BsDot),
  //     },
  //   ],
  // },
];
